import {CookieAttributes, cookieGenerateString, cookieParse} from "@wix/devzai-utils-common";

export function cookiesGetItem(key: string): string | undefined {
    return cookieParse(document.cookie)?.[key];
}

export function cookiesSetItem(key: string, value: string, attributes?: CookieAttributes): void {
    document.cookie = cookieGenerateString(key, value, attributes);
}

export function cookiesRemoveItem(key: string, attributes?: CookieAttributes): void {
    const attr: CookieAttributes = { ...attributes, expires: new Date(0) };
    document.cookie = cookieGenerateString(key, '', attr);
}
